// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"T5-z"};